export { CourseCollectionFragment } from './course-collection';
